import axios from "axios";
import { getToken } from "../../helpers/common";
import * as API_URL from "../../constants/api";

export const downloadPreLeadMarketing = async (filterData = {}) => {
  const token = getToken();
  const response = await axios.post(
    API_URL.PRE_LEAD_MARKETING_DOWNLOAD,
    { filterData },
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob", // ← critical for binary response
    },
  );
  let filename = "pre-leads-export";
  const disposition = response.headers["content-disposition"];
  if (disposition) {
    const match = disposition.match(/filename="?([^";\n]+)"?/);
    if (match?.[1]) filename = match[1].trim();
  }
  const contentType = response.headers["content-type"] || "";
  if (!filename.includes(".")) {
    if (contentType.includes("zip")) filename += ".zip";
    else if (contentType.includes("csv")) filename += ".csv";
  }

  const blobUrl = URL.createObjectURL(
    new Blob([response.data], { type: contentType }),
  );
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(blobUrl);
};

export const fetchPreLeadDownloadHistory = async (
  page = 1,
  recordsPerPage = 10,
  filterData = {},
) => {
  try {
    const token = getToken();
    const { post } = await import("../api");
    const result = await post(
      API_URL.PRE_LEAD_MARKETING_DOWNLOAD_HISTORY,
      { page, recordsPerPage, filterData },
      token,
    );
    return result;
  } catch (e) {
    return { success: false, data: {}, message: e.message };
  }
};
